export const environment = {
  production: true,
  appRoot: "https://new-test.backend.fynka.terrakodo.com",
  hostname: "test.fynka.terrakodo.com",
  langUrl: "https://management-tool-backend.terrakodo.com/api/get_language_content/",
  sentryDsn: "https://2e1a749c2f95189ba4bc21d00fa77e6c@sentry.terrakodo.com/3",
  hostUrl:"https://test.fynka.terrakodo.com",
};
